
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/choice/stage",
      function () {
        return require("private-next-pages/book/choice/stage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/choice/stage"])
      });
    }
  